/**
 * AppLovin Axon — EasySell COD Purchase Tracker
 * Fires axon("track","purchase") when EasySell thank-you modal appears.
 * Loaded as a theme asset to avoid inline-JS encoding issues.
 *
 * Product detection priority:
 *   1. window.ES_INITIAL_PRODUCT (EasySell runtime — handle + title)
 *   2. document.title / og:title meta tag
 *   3. URL path (fallback)
 *
 * Price detection priority:
 *   1. window.ES_TOTAL (EasySell runtime — actual order total)
 *   2. EasySell order summary DOM elements
 *   3. 690 THB fallback
 */
(function () {
  'use strict';

  var PREFIX = '[Axon-EasySell]';
  var EVENT_KEY = '96f6ed07-40af-4931-9be8-4e328999d73f';
  var fired = false;

  // Known product catalog — English names, Thai names, and SKU prefixes
  var PRODUCTS = [
    { matches: ['harmonate', '\u0e2e\u0e32\u0e23\u0e4c\u0e42\u0e21\u0e40\u0e19\u0e17', 'hmn'], id: 'harmonate', name: 'Harmonate', category: 'nutrio' },
    { matches: ['aniqa',     'anq'],                                                             id: 'aniqa',     name: 'Aniqa+',    category: 'nutrio' },
    { matches: ['ocella',    '\u0e42\u0e2d\u0e40\u0e0b\u0e25\u0e25\u0e48\u0e32', 'ocl'],        id: 'ocella',    name: "O'Cella",   category: 'riora' },
    { matches: ['regenic',   '\u0e23\u0e35\u0e40\u0e08\u0e19\u0e34\u0e04', 'rgn'],               id: 'regenic',   name: 'Regenic',   category: 'riora' },
    { matches: ['testonate', 'tsn'],                                                              id: 'testonate', name: 'Testonate', category: 'nutrio' },
    { matches: ['peptiva',   'ptv'],                                                              id: 'peptiva',   name: 'Peptiva',   category: 'dermova' }
  ];

  console.log(PREFIX, '=== Axon EasySell Purchase Tracker ===');

  // --- 1. Initialize Axon SDK ---
  !function (e, r) {
    var t = [
      'https://s.axon.ai/pixel.js',
      'https://res4.applovin.com/p/l/loader.iife.js'
    ];
    if (!e.axon) {
      var a = e.axon = function () {
        a.performOperation
          ? a.performOperation.apply(a, arguments)
          : a.operationQueue.push(arguments);
      };
      a.operationQueue = [];
      a.ts = Date.now();
      a.eventKey = EVENT_KEY;
      for (var n = r.getElementsByTagName('script')[0], o = 0; o < t.length; o++) {
        var i = r.createElement('script');
        i.async = true;
        i.src = t[o];
        n.parentNode.insertBefore(i, n);
      }
    }
  }(window, document);

  axon('init');
  axon('track', 'page_view');
  console.log(PREFIX, 'Axon initialized + page_view fired');

  // --- 2. Product matching helper ---
  function matchProduct(text) {
    if (!text) return null;
    var lower = text.toLowerCase();
    for (var i = 0; i < PRODUCTS.length; i++) {
      var p = PRODUCTS[i];
      for (var j = 0; j < p.matches.length; j++) {
        if (lower.indexOf(p.matches[j]) !== -1) {
          return p;
        }
      }
    }
    return null;
  }

  // --- 3. Product detection (multi-source) ---
  function detectProduct() {
    var product = null;
    var source = '';

    // Source 1: EasySell product data (most reliable — has handle, title, variants with SKU)
    if (window.ES_INITIAL_PRODUCT) {
      var esp = window.ES_INITIAL_PRODUCT;
      // Try handle, then title
      product = matchProduct(esp.handle) || matchProduct(esp.title);
      if (product) {
        source = 'ES_INITIAL_PRODUCT title/handle';
      }
      // Try SKU from first variant
      if (!product && esp.variants && esp.variants.length > 0) {
        var sku = esp.variants[0].sku || '';
        product = matchProduct(sku);
        if (product) source = 'ES_INITIAL_PRODUCT SKU (' + sku + ')';
      }
    }

    // Source 2: Page title (works on /pages/harmonate where title contains "Harmonate")
    if (!product) {
      product = matchProduct(document.title);
      if (product) source = 'document.title';
    }

    // Source 3: og:title meta tag
    if (!product) {
      var ogEl = document.querySelector('meta[property="og:title"]');
      if (ogEl) {
        product = matchProduct(ogEl.getAttribute('content'));
        if (product) source = 'og:title';
      }
    }

    // Source 4: URL path
    if (!product) {
      product = matchProduct(window.location.pathname);
      if (product) source = 'URL path';
    }

    if (product) {
      console.log(PREFIX, 'Product detected via', source, '→', product.name);
      return product;
    }

    console.log(PREFIX, 'No known product detected — using fallback');
    return { id: 'unknown', name: 'Unknown Product', category: 'unknown' };
  }

  // --- 4. Price detection (multi-source) ---
  function extractPrice() {
    // Source 1: EasySell order total (set at cart calculation time)
    if (typeof window.ES_TOTAL === 'number' && window.ES_TOTAL > 0) {
      console.log(PREFIX, 'Price from ES_TOTAL:', window.ES_TOTAL);
      return window.ES_TOTAL;
    }

    // Source 2: EasySell cart object
    try {
      var store = window.__easysell_store__ || window.__vue_store__;
      if (store && store.state && store.state.cart && store.state.cart.cart) {
        var total = store.state.cart.cart.totalPrice;
        if (total > 0) {
          console.log(PREFIX, 'Price from EasySell store:', total);
          return total;
        }
      }
    } catch (e) { /* ignore */ }

    // Source 3: DOM selectors for EasySell order summary
    var selectors = [
      '.es-order-summary .es-total-value',
      '.es-order-summary-total',
      '.es-total-price',
      '.es-price',
      '[data-es-total]',
      '.order-summary-total'
    ];
    for (var s = 0; s < selectors.length; s++) {
      var el = document.querySelector(selectors[s]);
      if (el) {
        var text = (el.textContent || el.getAttribute('data-es-total') || '').replace(/[^0-9.]/g, '');
        var num = parseFloat(text);
        if (num > 0) {
          console.log(PREFIX, 'Price from DOM (' + selectors[s] + '):', num);
          return num;
        }
      }
    }

    // Source 4: EasySell product variant price
    if (window.ES_INITIAL_PRODUCT && window.ES_INITIAL_PRODUCT.variants) {
      var variants = window.ES_INITIAL_PRODUCT.variants;
      if (variants.length > 0 && variants[0].price > 0) {
        var vPrice = parseFloat(variants[0].price);
        if (vPrice > 0) {
          console.log(PREFIX, 'Price from ES_INITIAL_PRODUCT variant:', vPrice);
          return vPrice;
        }
      }
    }

    console.log(PREFIX, 'Price fallback: 690 THB');
    return 690;
  }

  // --- 5. Fire purchase event ---
  function firePurchase() {
    if (fired) {
      console.log(PREFIX, 'Already fired — skipping duplicate');
      return;
    }
    fired = true;

    var product = detectProduct();
    var price = extractPrice();

    console.log(PREFIX, '=== FIRING AXON PURCHASE EVENT ===');
    console.log(PREFIX, 'Product:', product.name, '| Price:', price, 'THB');

    axon('track', 'purchase', {
      currency: 'THB',
      value: price,
      transaction_id: 'es-' + Date.now() + '-' + Math.random().toString(36).substr(2, 6),
      shipping: 0,
      tax: 0,
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_category_id: product.category,
        price: price,
        quantity: 1
      }]
    });

    console.log(PREFIX, 'Purchase event sent to Axon');
  }

  // --- 6. Modal detection ---
  function isModalVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetHeight > 10;
  }

  function checkModal() {
    var modal = document.getElementById('es-thanks-modal');
    if (modal && isModalVisible(modal)) {
      console.log(PREFIX, 'Thank-you modal detected!');
      firePurchase();
      return true;
    }
    return false;
  }

  // --- 7. MutationObserver ---
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var mutation = mutations[m];
        if (mutation.addedNodes && mutation.addedNodes.length) {
          for (var n = 0; n < mutation.addedNodes.length; n++) {
            var node = mutation.addedNodes[n];
            if (node.id === 'es-thanks-modal' || (node.querySelector && node.querySelector('#es-thanks-modal'))) {
              console.log(PREFIX, 'Modal node added to DOM');
              setTimeout(checkModal, 300);
            }
          }
        }
        if (mutation.target && mutation.target.id === 'es-thanks-modal') {
          if (mutation.type === 'attributes') {
            console.log(PREFIX, 'Modal attribute changed');
            setTimeout(checkModal, 200);
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    console.log(PREFIX, 'MutationObserver active');
  }

  // --- 8. Polling fallback (every 500ms for 5 minutes) ---
  var pollCount = 0;
  var maxPolls = 600;
  var pollInterval = setInterval(function () {
    pollCount++;
    if (fired || pollCount > maxPolls) {
      clearInterval(pollInterval);
      if (!fired) console.log(PREFIX, 'Polling timed out after 5 minutes');
      return;
    }
    checkModal();
  }, 500);

  console.log(PREFIX, 'Polling fallback active (500ms intervals, 5min timeout)');

})();
